/* eslint-disable */
import http from './httpService';
import { apiMETIS, apiNetzbetreiber } from '../config.json';

export function getNetzbetreiberData() {
	return http.get(`${apiNetzbetreiber}/grids`);
}

export function getSpannungsebeneData(id) {
	return http.get(`${apiNetzbetreiber}/grids/${id}`);
}

export function getLastgangDataResults(id) {
	return http.get(`${apiMETIS}/${id}`, {
		headers: {
			'Content-Type': 'application/json',
		},
	});
}

export function putLastgangData(id, data) {
	return http.put(`${apiMETIS}/${id}`, data, {
		headers: {
			'Content-Type': 'application/json',
		},
	});
}

export function postLastgangRaw(fileType, fileData, location_id) {
	return http.post(
		apiMETIS,
		{
			type: fileType,
			file: fileData,
			location_id: location_id,
		});
}
